import { Grid } from "@mui/material";
// import { UseFormReturn } from 'react-hook-form';

import {
  gridSize,
  gridSizeMdLg12,
  gridSizeMdLg3,
  gridSizeMdLg6,
  tabTextLabelSx,
  useTabsFormOnly,
} from "@/shared";
import {
  CustomTextField,
  CustomTextFieldNoForm,
  SampleCheckboxNoForm,
  TabTextLabel,
} from "@/shared/components/ui";
import type { Contrato } from "@/shared/interfaces";
import ContractStateChip from "../ContractStateChip";
import ClienteFibraBtnsServiceContract from "./ClienteFibraBtnsServiceContract";
// import type { ClienteFibraSummaryFormType } from './SaveContractFibra';
import dayjs from "dayjs";
import {
  // ClienteFibraNotifySummaryPart,
  ClienteInfoSummaryFormPart,
} from "./parts";
import { ClienteFibraPromocionesFormTab } from "./promociones";
import { UseFormReturn } from "react-hook-form";
import { ClienteFibraSummaryFormType } from "./SaveContractFibra";
import { EquipoAdicionalPreventaBooleans } from "@/erp/operaciones/preagendamiento/shared/components";
// import InfoUser from '@/shared/components/ui/InfoUser/InfoUser';
// import { DatosFormaPago } from '@/erp/clientes/cliente-update-data/shared';

export type ClienteFibraSummaryTFormabProps = {
  contract: Contrato;

  form: UseFormReturn<ClienteFibraSummaryFormType>;
};

const ClienteFibraSummaryTFormab: React.FC<ClienteFibraSummaryTFormabProps> = ({
  contract,
  form,
}) => {
  ///* hooks -------------------------
  const { handleMethodChange, valueTab } = useTabsFormOnly();

  ///* form -------------------------
  const { errors } = form.formState;

  const isPromotionActive =
    form.getValues()?.plan_data?.es_tercera_edad ||
      contract?.promociones_data?.[0]?.nombre == "PROMOCION CIUDADES"
      ? true
      : dayjs(contract?.agendamiento_data?.fecha_instalacion)
        .add(
          contract?.promociones_data?.[0]?.meses_descuento?.length! + 1,
          "month"
        )
        .isAfter(dayjs());

  return (
    <>
      {/* ============ top bar - plan options ============ */}

      <Grid
        item
        {...gridSizeMdLg12}
      >
        <Grid item {...gridSizeMdLg6}>
          <Grid container {...gridSizeMdLg12}>
            <ContractStateChip contract={contract} widthChip="100%" />
          </Grid>
          <ClienteFibraBtnsServiceContract contract={contract} />
        </Grid>

      </Grid>


      {/* ===================== Cliente Info ===================== */}

      <ClienteInfoSummaryFormPart
        contract={contract}
        handleMethodChange={handleMethodChange}
        valueTab={valueTab}
      />

      {/* ===================== Contract Info ===================== */}
      <TabTextLabel text="Datos del Contrato" pt="25px" pb={"1rem"} />
      <>
        <CustomTextField
          name="planLabel"
          label="Plan"
          control={form.control}
          defaultValue={form.getValues().planLabel || ""}
          error={errors.planLabel}
          helperText={errors.planLabel?.message?.toString() ?? ""}
          shrink
          disabled
        />
        <Grid item container spacing={2} sx={{ pt: 1 }}>
          <SampleCheckboxNoForm
            label="Contrato Físico"
            defaultValue={contract?.preventa_data?.requiere_contrato_fisico}
            disabled
            size={gridSizeMdLg6}
          />

          <SampleCheckboxNoForm
            label="Es tercera edad"
            defaultValue={contract?.prospecto_data?.es_tercera_edad}
            disabled
            size={gridSizeMdLg6}
          />


          <SampleCheckboxNoForm
            label="Es representante de persona con discapacidad"
            defaultValue={contract?.prospecto_data?.es_curador_tutor}
            disabled
            size={gridSizeMdLg6}
          />

          <SampleCheckboxNoForm
            label="Es bono humano"
            defaultValue={contract?.prospecto_data?.es_bono_humano}
            disabled
            size={gridSizeMdLg6}
          />

          <SampleCheckboxNoForm
            label="Ayuda social"
            defaultValue={contract?.prospecto_data?.es_ayuda_social}
            disabled
            size={gridSizeMdLg6}
          />
          <SampleCheckboxNoForm
            label="Es persona con discapacidad"
            defaultValue={contract?.prospecto_data?.es_discapacitado}
            disabled
            size={gridSizeMdLg6}
          />

        </Grid>

        {isPromotionActive && (
          <CustomTextFieldNoForm
            label="Promoción que Aplica"
            value={
              form.getValues()?.plan_data?.es_tercera_edad
                ? "PROMOCIÓN TERCERA EDAD"
                : contract?.promociones_data?.length! > 0
                  ? contract?.promociones_data?.[0]?.nombre
                  : "N/A"
            }
            shrink
            type="text"
            disabled
            size={gridSizeMdLg6}
          />
        )}

        {isPromotionActive && (
          <CustomTextFieldNoForm
            label="Fecha Inicio Promoción"
            value={
              contract?.promociones_data?.length! > 0 ||
                form.getValues()?.plan_data?.es_tercera_edad
                ? dayjs(contract?.agendamiento_data?.fecha_instalacion)
                  .add(1, "month")
                  .format("L")
                : "N/A"
            }
            shrink
            type="text"
            disabled
            size={gridSizeMdLg3}
          />
        )}

        {/* TODO Define the whole duration of the promotion */}
        {isPromotionActive && (
          <CustomTextFieldNoForm
            label="Fecha Fin Promoción"
            value={
              form.getValues()?.plan_data?.es_tercera_edad ||
                contract?.promociones_data?.[0]?.nombre == "PROMOCION CIUDADES" ||
                contract?.promociones_data?.[0]?.nombre == "PROMOCIÓN GREMIOS"
                ? "INDEFINIDO"
                : contract?.promociones_data?.length! > 0
                  ? dayjs(contract?.agendamiento_data?.fecha_instalacion)
                    .add(
                      contract?.promociones_data?.[0]?.meses_descuento
                        ?.length! + 1,
                      "month"
                    )
                    .format("L")
                  : "N/A"
            }
            shrink
            type="text"
            disabled
            size={gridSizeMdLg3}
          />
        )}

        <CustomTextField
          label="Tipo de Servicio"
          name="tipo_servicio"
          control={form.control}
          defaultValue={form.getValues().tipo_servicio || ""}
          error={errors.tipo_servicio}
          helperText={errors.tipo_servicio?.message}
          shrink
          type="tipo_servicio"
          disabled
          size={gridSizeMdLg6}
        />
        <CustomTextField
          label="Permanencia"
          name="permanencia"
          control={form.control}
          defaultValue={form.getValues().permanencia || ""}
          error={errors.permanencia}
          helperText={errors.permanencia?.message}
          shrink
          type="permanencia"
          disabled
          size={gridSizeMdLg6}
        />

        {/* <CustomTextFieldNoForm
          label="Valor Plan ($)"
          // name="plan_data.valor"
          // control={form.control}
          defaultValue={
            // form.getValues()?.plan_data?.es_tercera_edad ||
            contract?.promociones_data?.[0]?.nombre
              ? `${parseFloat(contract?.plan_data?.valor!).toString()}`
              : contract?.plan_data?.valor ?? ""
          }
          // error={errors.valor}
          // helperText={errors.valor?.message}
          shrink
          type="valor"
          disabled
          size={gridSizeMdLg6}
        /> */}
        <CustomTextFieldNoForm
          label="Valor Plan ($)"
          defaultValue={contract?.preventa_data?.valor_instalacion_total ?? ""}
          shrink
          type="valor"
          disabled
          size={gridSizeMdLg6}
        />

        {isPromotionActive && (
          <CustomTextFieldNoForm
            label="Valor Promocional ($)"
            defaultValue={
              contract?.promociones_data?.[0]?.nombre
                ? `${(
                  parseFloat(contract?.plan_data?.valor!) -
                  (parseFloat(contract?.plan_data?.valor!) *
                    parseFloat(
                      contract?.promociones_data?.[0]?.valor_descuento
                    )) /
                  100
                ).toString()}`
                : contract?.plan_data?.valor ?? ""
            }
            shrink
            type="valor"
            disabled
            size={gridSizeMdLg6}
          />
        )}

        <CustomTextField
          label="Valor Instalación ($)"
          name="valor_instalacion_total"
          control={form.control}
          defaultValue={form.getValues()?.valor_instalacion_total || ""}
          error={errors.valor_instalacion_total}
          helperText={errors.valor_instalacion_total?.message}
          shrink
          type="valor_instalacion_total"
          disabled
          size={gridSizeMdLg6}
        />

        <CustomTextField
          name="numero_contrato"
          label="No. Contrato"
          control={form.control}
          defaultValue={form.getValues().numero_contrato || ""}
          error={errors.numero_contrato}
          helperText={errors.numero_contrato?.message?.toString() ?? ""}
          shrink
          disabled
          size={isPromotionActive ? gridSizeMdLg6 : gridSize}
        />

        <CustomTextFieldNoForm
          label="Es migración de Tecnologia"
          defaultValue={contract?.es_migracion_tecnologia ? "SI" : "NO"}
          shrink
          type="text"
          disabled
          size={gridSizeMdLg6}
        />

        <CustomTextFieldNoForm
          label="Fecha migración de Tecnologia"
          defaultValue={
            contract?.fecha_migracion_tecnologia
              ? new Date(contract.fecha_migracion_tecnologia)
                .toISOString()
                .split("T")[0]
              : ""
          }
          shrink
          type="date"
          disabled
          size={gridSizeMdLg6}
        />

        <TabTextLabel
          text="Promoción"
          sx={{
            ...tabTextLabelSx,
            pb: "3px",
            pt: "54px",
            mt: "0px",
          }}
        />
        <ClienteFibraPromocionesFormTab contract={contract} />

        <TabTextLabel
          text="Equipos adicionales"
          sx={{
            ...tabTextLabelSx,
            mt: "0px",
          }}
        />

        <EquipoAdicionalPreventaBooleans preventa={contract.preventa_data!} />


      </>
    </>
  );
};

export default ClienteFibraSummaryTFormab;
